/**
 * CCMS SDK version constant
 */
export const CCMS_SDK_VERSION = '0.0.1';
//# sourceMappingURL=Config.js.map